import React from "react"
import { Link } from "gatsby"
import Layout from "../../components/Layout"
import Pagetitle from "../../components/Pagetitle"
import Seo from "../../components/Seo"
import RelatedPlatforms from "../../components/RelatedPlatforms"
import { PLATFORM_GUIDE_OG_IMAGE } from "../../data/platforms"

const IdealoPage = () => (
  <Layout>
    <Seo
      title="Adding your feed to Idealo Sponsored Products"
      description="Step-by-step instructions for connecting your Upfeed product feed to Idealo to list and sponsor your products on Europe's leading price comparison platform."
      image={PLATFORM_GUIDE_OG_IMAGE}
    />
    <div className="container">
      <div className="row justify-content-center">
        <div className="getting-started col-md-8">
          <Link to="/getting-started/#platforms" className="back-link">
            ← All platforms
          </Link>
          <Pagetitle>Adding your feed to Idealo Sponsored Products</Pagetitle>
          <p>
            Follow these steps to connect your UpFeed product feed to Idealo so
            your products appear on Europe's leading price comparison platform.
            Sponsored Products allows you to boost visibility and drive traffic
            on a cost-per-click basis.
          </p>

          <div className="prerequisites">
            <p>Before you start, make sure you have:</p>
            <ul>
              <li>
                <Link to="/getting-started/#generate">
                  Generated your product feed
                </Link>{" "}
                and copied the feed URL from the app homepage.
              </li>
              <li>
                An Idealo seller account. You can apply at{" "}
                <a href="https://www.idealo.de" target="_blank" rel="noreferrer">
                  idealo.de
                </a>
                .
              </li>
            </ul>
          </div>

          <h2>Connecting your product feed to Idealo</h2>
          <ul>
            <li>
              Log in to your Idealo seller account and go to 'Product data' in
              your account menu.
            </li>
            <li>Select 'Product feed' from the submenu.</li>
            <li>Enter your UpFeed product feed URL in the feed URL field.</li>
            <li>
              Set the update schedule to 'Daily' to keep prices and availability
              current — this is important for compliance with Idealo's listing
              requirements.
            </li>
            <li>
              Idealo will automatically fetch and validate your feed. You will
              receive a notification once your products are live.
            </li>
          </ul>

          <h2>Setting up Sponsored Products</h2>
          <p>
            Once your products are listed on Idealo, navigate to the 'Sponsored
            Products' section in your seller account. Set your CPC bids and
            daily budget to boost the visibility of your products in Idealo's
            search results and category pages.
          </p>

          <RelatedPlatforms currentSlug="idealo" />
        </div>
      </div>
    </div>
  </Layout>
)

export default IdealoPage
